/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_Point_0_LabelInputs */

const en_visa_o1_point_0_label = /** @type {(inputs: Visa_O1_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole-Profile Assessment`)
};

const pt_visa_o1_point_0_label = /** @type {(inputs: Visa_O1_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliação do Perfil Completo`)
};

const es_visa_o1_point_0_label = /** @type {(inputs: Visa_O1_Point_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluación del Perfil Completo`)
};

/**
* | output |
* | --- |
* | "Whole-Profile Assessment" |
*
* @param {Visa_O1_Point_0_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_point_0_label = /** @type {((inputs?: Visa_O1_Point_0_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_Point_0_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_point_0_label(inputs)
	if (locale === "es") return es_visa_o1_point_0_label(inputs)
	return en_visa_o1_point_0_label(inputs)
});